var map = {
	"./1.jpg": 87065,
	"./2.jpg": 32140,
	"./3.jpg": 45539,
	"./4.jpg": 84334,
	"./5.jpg": 3741,
	"./6.jpg": 83465,
	"./7.jpg": 89825,
	"components/Project/img/panels/1.jpg": 87065,
	"components/Project/img/panels/2.jpg": 32140,
	"components/Project/img/panels/3.jpg": 45539,
	"components/Project/img/panels/4.jpg": 84334,
	"components/Project/img/panels/5.jpg": 3741,
	"components/Project/img/panels/6.jpg": 83465,
	"components/Project/img/panels/7.jpg": 89825
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25455;